import { useState } from "react";
import { diagrams } from "./architecture";
import { MermaidDiagram } from "@/components/diagrams/MermaidDiagram";

export function AboutArchitecture() {
  const ids = Object.keys(diagrams);
  const [active, setActive] = useState<string>(ids[0] ?? "systemContext");
  const current = diagrams[active] ?? diagrams[ids[0]!];

  return (
    <div style={{ display: "grid", gridTemplateColumns: "240px 1fr", gap: 16 }} className="lex-about-arch">
      <aside className="card" style={{ padding: 8, alignSelf: "start" }}>
        <div className="lex-eyebrow" style={{ padding: "8px 10px 4px" }}>DIAGRAMS</div>
        {ids.map((id) => {
          const d = diagrams[id]!;
          const isActive = id === active;
          return (
            <button
              key={id}
              type="button"
              onClick={() => setActive(id)}
              aria-pressed={isActive}
              style={{
                display: "block", width: "100%", textAlign: "left",
                padding: "10px 12px", border: "none", cursor: "pointer",
                borderRadius: "var(--r-md)",
                background: isActive ? "var(--md-secondary-container)" : "transparent",
                color: isActive ? "var(--md-on-secondary-container)" : "var(--md-on-surface)",
                font: "var(--t-title-sm)",
              }}
            >
              <div>{d.title}</div>
              <div style={{ font: "var(--t-body-sm)", color: "var(--md-on-surface-var)", marginTop: 2 }}>
                {d.caption}
              </div>
            </button>
          );
        })}
      </aside>
      <div>
        {current && (
          <MermaidDiagram
            key={current.id}
            source={current.source}
            title={current.title}
            caption={current.caption}
            notes={current.notes}
          />
        )}
      </div>
    </div>
  );
}

export default AboutArchitecture;
